import React from "react";
import { useState } from "react";
import { CapacityPicker } from "../../forms/capacityPicker/capacityPicker";
import { Capacity } from "../../forms/capacityPicker/capacityPicker";
import { ListActionLabel } from "./listActionLabel";
import styles from "./listActions.css";

interface Props {
  text: string;
  onChange: (capacity: Capacity) => void;
  itemsProvider: () => Capacity[];
}

export const ListAgentCapacityAction = ({ onChange, text, itemsProvider }: Props) => {
  const [isPicking, setIsPicking] = useState(false);

  return isPicking ? (
    <CapacityPicker
      onChange={onChange}
      itemsProvider={itemsProvider}
      className={styles["action-dropdown-capacity"]}
      onOutsideClick={() => setIsPicking(false)}
      onStateChange={(_, state) => (!state.isOpen ? setIsPicking(false) : undefined)}
      initialIsOpen
    />
  ) : (
    <ListActionLabel text={text} onClick={() => setIsPicking(true)} />
  );
};
